import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/ui/Header";
import HeroSection from "./components/HeroSection";
import EducationalPreview from "./components/EducationalPreview";
import SearchSection from "./components/SearchSection";
import ContactInformation from "../contact-support/components/ContactInformation";
import Footer from "./components/Footer";

const Homepage = () => {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);

  const handleSearch = ({ keyword, brand }) => {
    console.log("Search initiated:", keyword, brand);
  };
  return (
    <>
      <Helmet>
        {/* Primary SEO Title */}
        <title>
          Buy genuine and OEM grade-parts for your automobile at Kharbanda
          Motors
        </title>

        {/* Meta Description (optimized for CTR & search intent) */}
        <meta
          name="description"
          content="Find reliable genuine auto parts at Kharbanda Motors. Explore our car spare parts designed to give your vehicle the perfect fit and unmatached performance."
        />

        {/* High Volume Keywords */}
        <meta
          name="keywords"
          content="car spare parts India, buy car parts online, OEM car parts India, genuine auto parts Prayagraj, Hyundai spare parts, Mahindra spare parts, Maruti car spares, Tata auto components, Toyota genuine parts, automotive spare parts dealer Uttar Pradesh, OEM parts Asia, auto parts supplier India, car accessories and components, Kharbanda Motors Prayagraj"
        />

        {/* Robots + Canonical */}
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://kharbandamotors.com/" />

        {/* Open Graph (Facebook / LinkedIn / WhatsApp preview) */}
        <meta
          property="og:title"
          content="Buy genuine and OEM grade-parts for your automobile at Kharbanda Motors"
        />
        <meta
          property="og:description"
          content="Find reliable genuine auto parts at Kharbanda Motors. Explore our car spare parts designed to give your vehicle the perfect fit and unmatached performance."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://kharbandamotors.com/" />
        <meta
          property="og:image"
          content="https://kharbandamotors.com/assets/kharbanda-og-image.jpg"
        />

        {/* Geo-targeting for Local + Regional SEO */}
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.placename" content="Prayagraj" />
        <meta name="geo.position" content="25.4358;81.8463" />
        <meta name="ICBM" content="25.4358,81.8463" />
        <meta httpEquiv="content-language" content="en-IN" />

        {/* Schema Markup (JSON-LD for Local Business) */}
        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "AutoPartsStore",
      "name": "Kharbanda Motors",
      "image": "https://kharbandamotors.com/Untitled-removebg-preview (11).webp",
      "url": "https://kharbandamotors.com/",
      "telephone": "+91 8573036150",
      "email": "contact@kharbandamotors.com",
      "priceRange": "₹₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "28, Nawab Yusuf Rd, Civil Lines",
        "addressLocality": "Prayagraj",
        "addressRegion": "Uttar Pradesh",
        "postalCode": "211001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 25.4358,
        "longitude": 81.8463
      },
      "openingHoursSpecification": [{
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"
        ],
        "opens": "10:00",
        "closes": "20:00"
      }],
      "sameAs": [
        "https://www.facebook.com/kharbandamotors",
        "https://www.instagram.com/kharbandamotors",
      ],
      "areaServed": {
        "@type": "Place",
        "name": ["India", "South Asia", "Asia", "Worldwide"]
      },
      "description": "Kharbanda Motors is a trusted OEM car parts supplier in Prayagraj, Uttar Pradesh, India. Offering Hyundai, Mahindra, Maruti, Tata, and Toyota spare parts with worldwide delivery and quality assurance."
    }
    `}
        </script>
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />
        <main>
          <HeroSection />
          <SearchSection />
          <EducationalPreview />
          <div className=" max-w-6xl mx-auto mb-12">
            <ContactInformation />
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};
export default Homepage;
